import { render, staticRenderFns } from "./DarkFaq.vue?vue&type=template&id=6e494d36&"
import script from "./DarkFaq.vue?vue&type=script&setup=true&lang=js&"
export * from "./DarkFaq.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports